// Claves de localStorage usadas en toda la app. Centralizadas para evitar
// magic strings y desajustes entre lecturas y escrituras.
export const STORAGE_KEYS = {
  USER: "user",
  TOKEN: "token",
  LANGUAGE: "language",
  SETTING: "setting",
  PROJECT_ASSIGNMENTS: "project-assignments",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
